// src/lib/api.js
import { auth } from "../firebase";

const DEFAULT_BASE = import.meta.env.VITE_BACKEND_URL;

if (!DEFAULT_BASE) {
  throw new Error("VITE_BACKEND_URL is not configured.");
}

async function getAuthHeaders() {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("Not authenticated. Please sign in.");
  }

  const token = await user.getIdToken();

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export async function analyze(message, { signal } = {}) {
  const headers = await getAuthHeaders();

  const res = await fetch(`${DEFAULT_BASE}/analyze`, {
    method: "POST",
    mode: "cors",
    credentials: "omit",
    headers,
    body: JSON.stringify({ message }),
    signal,
  });

  if (!res.ok) {
    throw new Error(
      res.status === 401
        ? "Authentication failed. Please sign in again."
        : res.status === 503
          ? "Service temporarily unavailable."
          : "DAT backend request failed.",
    );
  }
  return res.json();
}
